import React from 'react';
import Spinner from "react-bootstrap/cjs/Spinner";
import Logo from "./Logo";

function LoadingSpinner(props){
    return <div id={"loading"}>
        <Spinner animation="grow" variant="danger"/>
        <Logo />
    </div>;
}

export default LoadingSpinner;